import type { CarId } from '../game/cars';
import { supabase } from './supabase';

// ─────────────────────────────────────────────────────────────────────────────
// The Sunken Fortress's score keeping (supabase/migrations/20261040_sunken_tower.sql).
// The tower itself is generated in the browser (game/fortress/gen.ts) from the
// class and the week the server says it is. A week's first clear wins a rare
// fish and a race car the student doesn't have yet (game/cars.ts).
// ─────────────────────────────────────────────────────────────────────────────

export const TOWER_COST = 3;

export type TowerRow = { me: boolean; name: string | null; won: boolean; secs: number | null; floor: number; tries: number };
/** A first clear's prize (games never pay sand dollars; `coins` is always 0 now). */
export type TowerReward = { coins: number; species?: string | null; rarity?: string; new?: boolean; car?: string | null; balance?: number; already?: boolean };

function check<T>(res: { data: unknown; error: { message: string } | null }): T {
  if (res.error) throw new Error(res.error.message);
  return res.data as T;
}

export const towerBoard = async (cid: string) => check<{ week: string; board: TowerRow[] }>(await supabase.rpc('ocean_tower_board', { cid }));
export const enterTower = async (cid: string) => check<{ run: string; week: string; balance: number }>(await supabase.rpc('ocean_tower_enter', { cid }));
export const towerFloor = async (run: string, reached: number) => { await supabase.rpc('ocean_tower_floor', { run, reached }); };
export const finishTower = async (run: string, won: boolean) => check<TowerReward>(await supabase.rpc('ocean_tower_finish', { run, won }));
/** The race cars this student has won (game/cars.ts; the Racer isn't listed, everyone has it). Teachers get them all. */
export const myCars = async () => check<CarId[]>(await supabase.rpc('ocean_my_cars'));
